import React, { Component } from 'react'

class CategoryItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: true,
      guide_category_name: '',
      image_url: '',
      image: '',
      image_error: ''
    }
  }

  _handleCancelClick () {
    this.props.cancel()
  }
  _handleSaveClick () {
    console.log('saving data...')
    const {
      guide_category_name,
      image
    } = this.state

    this.props.saveData({guide_category_name}, image)
    this.setState({ edit: false })
  }

  async _handleImageChange (e) {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById('image').value = ''
  }

  _renderImageLabel () {
    if (this.state.image_url) {
      return (
        <div className="label_container">
          <label className="image_input_label image_selected" htmlFor="image">
            <img className="img-responsive" src={this.state.image_url} alt=""/>
          </label>
          <div className="delete_container" onClick={this._resetImage.bind(this)}>
            <span></span>
            <span></span>
          </div>
        </div>
      )
    }
    return (
      <div className="label_container">
        <label className="image_input_label image_blank" htmlFor="image">
          <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </label>
      </div>
    )
  }

  _renderRightBlock () {
    return (
      <div className="right_block">
        <div className="input_group">
          <label htmlFor="name">件名</label>
          <input type="text" value={ this.state.guide_category_name } onChange={ this._handleUpdateContent.bind(this, 'guide_category_name') }/>
        </div>
      </div>
    )
  }

  _renderBtns () {
    return [
      <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
      <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
    ]
  }

  render () {
    return (
      <article className="categories">
        <div className="info_inner admin_inner flex justify-between">
          <div className="input-group flex column">
            <label className="label text-center" htmlFor="image">
              <span className="smallest file_requirements">（JPEG・PNGファイルのみ）</span>
            </label>
            <div className="image_input_container flex">
              { this._renderImageLabel() }
              <div>
                <div className="image_error small">{ this.state.image_error }</div>
                <input
                  type="file"
                  id="image"
                  onChange={this._handleImageChange.bind(this)}
                />
              </div>
            </div>
          </div>

          <div className="contents flex top_label">
            { this._renderRightBlock()}
          </div>
        </div>

        <div className="btn_group flex">
          { this._renderBtns() }
        </div>
      </article>
    )
  }
}

export default CategoryItem



// WEBPACK FOOTER //
// ./src/components/Properties/Guides/AddCategory.js